import { c as _c } from "react/compiler-runtime";
import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { serializeActionInput } from '../lib/analytics';
const DEFAULT_ACTION_TYPE = 'selected' as const;
export function useFunnelPageAction() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const firePageActionEvent = usePageAction(t0);
  let t1;
  if ($[1] !== firePageActionEvent) {
    t1 = (stepId, branchId, submittedAnswer) => {
      firePageActionEvent({
        action_name: `${stepId}_selected`,
        action_input: serializeActionInput(submittedAnswer),
        action_section: stepId,
        action_type: DEFAULT_ACTION_TYPE,
        page_branch_name: branchId
      });
    };
    $[1] = firePageActionEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}